module.exports = __webpack_public_path__ + "static/rpa_tailored-71ea3158c9d5f4854fc3ec01fdc314e6.png";